import React from 'react';
import {
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Chip,
} from '@mui/material';

import { format, isValid, parse, parseISO } from 'date-fns';
import { statusColorChipSx } from '../../../../app/statusColorChip';

const fmtMoney = (v) => {
  if (v === undefined || v === null) return '—';
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(v));
};

const fmtDateOnly = (s) => {
  if (s === undefined || s === null || s === '') return '—';
  const trimmed = String(s).trim();
  let d = parseISO(trimmed.replace(' ', 'T'));
  if (!isValid(d)) {
    d = parse(trimmed, 'yyyy-MM-dd HH:mm:ss', new Date(0));
  }
  if (!isValid(d) && trimmed.length >= 10) {
    d = parse(trimmed.substring(0, 10), 'yyyy-MM-dd', new Date(0));
  }
  if (!isValid(d)) return trimmed;
  return format(d, 'dd/MM/yyyy');
};

const RecentOrdersPanel = ({ orders, translate }) => {
  const rows = Array.isArray(orders) ? orders : [];

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        height: '100%',
        border: '1px solid',
        borderColor: 'divider',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
        {translate('home.dashboard.recent_orders')}
      </Typography>
      {rows.length === 0 ? (
        <Box sx={{ py: 3, color: 'text.secondary', textAlign: 'center' }}>{translate('home.dashboard.no_orders')}</Box>
      ) : (
        <TableContainer sx={{ maxHeight: 320, overflowX: 'auto' }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ bgcolor: 'background.paper' }}>{translate('home.dashboard.col_order')}</TableCell>
                <TableCell sx={{ bgcolor: 'background.paper', display: { xs: 'none', sm: 'table-cell' } }}>{translate('home.dashboard.col_customer')}</TableCell>
                <TableCell sx={{ bgcolor: 'background.paper' }}>{translate('home.dashboard.col_status')}</TableCell>
                <TableCell sx={{ bgcolor: 'background.paper', display: { xs: 'none', sm: 'table-cell' } }} align="right">
                  {translate('home.dashboard.col_total')}
                </TableCell>
                <TableCell sx={{ bgcolor: 'background.paper', display: { xs: 'none', md: 'table-cell' } }}>{translate('home.dashboard.col_updated')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((o) => {
                const customSx = statusColorChipSx(o.status_color);
                return (
                  <TableRow key={o.id} hover>
                    <TableCell>
                      <Box>
                        <Typography variant="body2">{o.number || o.id}</Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ display: { xs: 'block', sm: 'none' } }}>
                          {o.customer_name || '—'}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>{o.customer_name || '—'}</TableCell>
                    <TableCell>
                      <Chip
                        label={o.status_label || o.status}
                        size="small"
                        {...(customSx ? { sx: customSx } : { variant: 'outlined', color: 'default' })}
                      />
                    </TableCell>
                    <TableCell align="right" sx={{ display: { xs: 'none', sm: 'table-cell' } }}>{fmtMoney(o.total_value)}</TableCell>
                    <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>{fmtDateOnly(o.updated_at)}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Paper>
  );
};

export default RecentOrdersPanel;
